import { type FC } from 'react';
import { useMounted } from '@mantine/hooks';
import { ActionIcon, Tooltip, useMantineColorScheme } from '@mantine/core';
import { colorSchemesIconsMap, colorSchemesMap } from './constants';
import styles from './ThemeSwitcher.module.css';

export const ThemeSwitcher: FC = () => {
    const mounted = useMounted();
    const { colorScheme, setColorScheme } = useMantineColorScheme();
    const resolvedColorScheme = mounted ? colorScheme : 'auto';

    const nextColorScheme = colorSchemesMap[resolvedColorScheme];
    const Icon = colorSchemesIconsMap[resolvedColorScheme];

    const handleChangeTheme = () => {
        setColorScheme(nextColorScheme);
    };

    return (
        <Tooltip
            label={`Переключиться на ${nextColorScheme} режим`}
            withArrow
        >
            <ActionIcon
                className={styles.switcher}
                onClick={handleChangeTheme}
                variant='transparent'
                size={36}
                aria-label='Toggle color scheme'
            >
                <Icon
                    className={styles.icon}
                    size={20}
                    stroke={1.7}
                />
            </ActionIcon>
        </Tooltip>
    );
};
